import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { formatDate, generateUUID, toDBDate } from '../../Utils/CommonUtils';
import { ConfigDataProvider } from '../config-data/config-data';
import { UsersStoreProvider } from '../users-store/users-store';
import { TranslateProvider } from '../translate/translate';
import { Messages } from '../../Interface/CommonDataBaseInterface';
import { ConnectionProvider } from '../connection/connection';

@Injectable()
export class MessagesStoreProvider {

	private db = new DatabaseProvider();
	public messageList: BehaviorSubject<any> = new BehaviorSubject([]);
	public messageTemplateList: BehaviorSubject<any> = new BehaviorSubject([]);
	public syncMessagesObservable$: BehaviorSubject<any> = new BehaviorSubject(false);
	public showSyncMessagesError$: BehaviorSubject<any> = new BehaviorSubject(false);

	private userList = [];

	constructor(
		private configDataProvider: ConfigDataProvider,
		private usersStore: UsersStoreProvider,
		private translateProvider: TranslateProvider,
		private connection: ConnectionProvider,
	) {

		this.usersStore.usersList
			.subscribe((list) => {
				this.userList = [...list];
			})

		this.usersStore.loadList().then(() => { }).catch((e) => { });

	}

	addBatch(messageList) {

		return new Promise((resolve, reject) => {

			this.db.messages.clear().then(() => {

				messageList.forEach((tmpMessage) => {
					tmpMessage.appstatus = "";
					tmpMessage.read = "";
				});

				this.db.messages.bulkAdd(messageList).then((data) => {
					this.loadList()
					resolve(data)
				}).catch((e) => {
					reject(e);
				})

			}).catch((e) => {
				reject(e);
			})

		})

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.messages.where("appstatus").notEqual("DELETED").toArray().then((list) => {

				this.manipulateList(list).then((filteredList) => {
					this.messageList.next(filteredList);
					resolve(true)
				}).catch((e) => { reject(e) });

			}).catch((e) => {

				reject(e);

			});

		})


	}

	private manipulateList(messageList) {

		return new Promise((resolve, reject) => {

			let messages = []

			var tempMsgList = [];
			if (messageList && messageList.length > 0) {

				messageList.forEach((v) => {
					var exist = tempMsgList.filter((e) => { return e.conversationid == v.conversationid });
					if (exist.length <= 0) {

						var a = messageList.filter((val) => { return val.conversationid == v.conversationid })
						var b = a.sort((d1, d2) => {
							let t1 = d1.datecreated.toString().replace(" ", "T");
							let t2 = d2.datecreated.toString().replace(" ", "T");
							return new Date(t2).getTime() - new Date(t1).getTime()
						});
						tempMsgList.push(b[0])
					}
				});

				var currentuser = this.configDataProvider.getUserData();

				if (tempMsgList.length > 0) {
					for (var i = 0; i < tempMsgList.length; i++) {

						var classname = 'item msgitem';
						var read = false;

						if (tempMsgList[i].readalready != '' && tempMsgList[i].readalready != null && tempMsgList[i].readalready.indexOf(currentuser.id) != -1) {
							classname += ' read';
							read = true;
						}
						else {
							classname += ' notread';
							read = false;
						}
						// var upic = './assets/imgs/avatar.jpg';

						let userList = this.userList && this.userList.length > 0 ? this.userList : this.usersStore.usersList.getValue();
						var uData = userList.filter((user) => {
							return tempMsgList[i].senderuserid == user.id
						});

						var upic = uData && uData.length > 0 ? uData[0].picture : "./assets/imgs/avatar.jpg ";
						var subtypeicon = '';

						if (tempMsgList[i].subtype != '') {
							if (tempMsgList[i].subtype == 'info') {
								subtypeicon = 'ios-checkmark-circle';
							}
							else if (tempMsgList[i].subtype == 'alert') {
								subtypeicon = 'ios-alert-outline';
							}
							else if (tempMsgList[i].subtype == 'warning') {
								subtypeicon = 'ios-alert';
							}
						}

						var sentbymeclass = 'notsentbyme';
						if (tempMsgList[i].senderuserid == currentuser.id) {
							sentbymeclass = 'sentbyme';
						}

						var bests = "";
						if (tempMsgList[i].bestemmelingen == 'Everyone') {
							bests = this.translateProvider.getTranslateKey('EVERYONE')
						}
						else {
							bests = tempMsgList[i].bestemmelingen;
						}
						let fname = uData && uData.length > 0 ? uData[0].fname : "";
						let message = {
							id: tempMsgList[i].id,
							fname: fname,
							userpicture: upic,
							subject: tempMsgList[i].subject,
							tempDateCreated: tempMsgList[i].datecreated,
							datecreated: formatDate(tempMsgList[i].datecreated),
							classname: classname,
							conversationid: tempMsgList[i].conversationid,
							senderuserid: tempMsgList[i].senderuserid,
							sentbymeclass: sentbymeclass,
							read: read,
							bestemmelingen: bests,
							slided: false,
							appstatus: tempMsgList[i].appstatus,
							readalready: tempMsgList[i].readalready,
							subtypeicon: subtypeicon
						}
						messages.push(message);
						messages.sort((d1, d2) => {
							d2.tempDateCreated = d2.tempDateCreated.toString().replace(" ", "T");
							d1.tempDateCreated = d1.tempDateCreated.toString().replace(" ", "T");
							return new Date(d2.tempDateCreated).getTime() - new Date(d1.tempDateCreated).getTime();
						});
					}
				}
				// messages.sort((d1, d2) => {
				// 	return new Date(d2.tempDateCreated).getTime() - new Date(d1.tempDateCreated).getTime();
				// });
				resolve(messages);
			}

			resolve(messages);
		})
	}


	addToMessageTempale(messageTemplateList) {

		return new Promise((resolve, reject) => {

			this.db.messageTemplates.clear().then(() => {

				this.db.messageTemplates.bulkAdd(messageTemplateList).then((data) => {
					this.loadMesageTemplates();
					resolve(data);
				}).catch((e) => reject(e))

			}).catch((e) => reject(e))

		})

	}

	loadMesageTemplates() {

		return new Promise((resolve, reject) => {

			this.db.messageTemplates.toArray().then((data) => {

				let list = [];

				if (data && data.length > 0) {


					data.forEach((t: any) => {
						t.selected = false;
						t.message = t.message.replace(/<p>/g, "");
						t.message = t.message.replace(/<\/p>/g, "");
						t.org_message = t.message;
						t.message = t.message.replace(/<br \/>/g, "\n");
						t.message = t.message.replace(/(\\n)+(\*+)?/g, '\n').replace(/\n{2,}/g, '\n');						
						// t.message = t.message.replace(/['"]+/g, "");
					})
					list = [...data]
				}

				this.messageTemplateList.next(list);

				resolve(true)

			})

		})

	}

	addMessageIntoLocalDB(message: Messages) {


		return new Promise((resolve, reject) => {

			this.db.messages.add(message).then((data) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncMessagesObservable$.next(true);
					}, 1500);
				} else {
					this.showSyncMessagesError$.next(true);
				}

				this.loadList().then(() => {
					resolve(data)
				}).catch((e) => { reject(e) });

			}).catch((e) => {
				reject(e);
			});

		});

	}


	addMessageWhenAddedAttachments(message: Messages) {

		return new Promise((resolve, reject) => {

			this.db.messages.add(message).then((data) => {

				resolve(data);

			}).catch((e) => {

				reject(e);

			});

		})

	}

	updateMessage(id, item) {

		return new Promise((resolve, reject) => {

			this.db.messages.update(id, item).then((res) => {

				resolve(res);

			}).catch((e) => {
				console.log(e);
				reject(e);
			})

		})

	}

	deleteMessage(id) {

		return new Promise((resolve, reject) => {

			this.db.messages.delete(id).then(() => {
				resolve(true);
			}).catch((e) => {
				reject(e);
			})

		})


	}


	deleteMessageLocal(id, item: Messages) {

		return new Promise((resolve, reject) => {

			this.db.messages.update(id, item).then((res) => {

				if (this.connection.isOnline()) {
					setTimeout(() => {
						this.syncMessagesObservable$.next(true);
					}, 1500);
				} else {
					this.showSyncMessagesError$.next(true);
				}
				resolve(res);
			}).catch((e) => {
				console.error(e);
				reject(e);
			})

		})

	}

	markAsRead(messageId, message: Messages) {

		let currentuser = this.configDataProvider.getUserData();
		let readalready = "";
		let appstatus = "";

		if (message.readalready == null || message.readalready.indexOf(currentuser.id) === -1) {

			if (message.appstatus.indexOf('READ') === -1) {

				if (message.appstatus.length == 0) {
					appstatus = 'READ';
				} else {
					appstatus = message.appstatus + ";" + 'READ';
				}

				if (message.readalready == '' || message.readalready == null) {
					readalready = currentuser.id + ";" + toDBDate();
				} else {
					readalready = message.readalready + ',' + currentuser.id + ";" + toDBDate();
				}
			}

			this.db.messages.where({ conversationid: message.conversationid }).toArray().then((data) => {
				if (data && data.length > 0) {
					for (let i = 0; i < data.length; i++) {
						this.db.messages.update(data[i].id, { readalready: readalready, appstatus: appstatus }).then(() => { }).catch((e) => { console.log(e) })
					}
				}
			}).catch((e) => {
				console.log(e);
			});

			setTimeout(() => {
				this.syncMessagesObservable$.next(true);
			}, 1000);
		}

	}

	getMessageObject() {
		return {
			id: generateUUID(),
			senderuserid: "",
			documentid: "",
			archive: "",
			read: "",
			readbefore: "",
			datecreated: "",
			readon: "",
			type: "message",
			subject: "",
			msgtext: "",
			dossierid: "",
			temp: "",
			bestemmelingen: "",
			afdeling: "",
			categorie: "",
			commentaar: "",
			werkbonseq: "",
			status: "",
			dateexecuted: "",
			userexecuted: "",
			usermodified: "",
			datemodified: "",
			permissiontext: "",
			customercode: this.configDataProvider.getCustomerCode(),
			kamer: "",
			bewonernaam: "",
			datearchived: "",
			userarchived: "",
			werkbontype: "",
			bestemmelingenids: "",
			conversationid: "",
			attachmentids: "",
			caredocfileattachments: "",
			source: "",
			deleted: "",
			messagestatus: "",
			readalready: "",
			appstatus: "",
			realbestemmelingenids: "",
			subtype: ""
		};

	}

}



// WEBPACK FOOTER //
// ./src/providers/messages-store/messages-store.ts